import vm from '~/main'
export default {
  $routerPushQueryParams: (paramName, value) => {
    let query = Object.assign({}, vm.$route.query)
    if (value.length) {
      query[paramName] = value
    } else delete query[paramName]
    if (query.page) query.page = 1
    vm.$router.push({ query }).catch(() => {})
  },
  $routerPushQuerySort: (paramName, value) => {
    let query = Object.assign({}, vm.$route.query)
    if (paramName.length) {
      query.sort_param = paramName
    } else delete query.sort_params
    if (value.length) {
      query.sort_value = value
    } else delete query.sort_value
    query.page = 1
    vm.$router.push({ query }).catch(() => {})
  },
  $filterQueryParams: (keys) => {
    let result = ''
    for (let key = 0; key < keys.length; key++) {
      let obj = vm.$route.query[keys[key]] ? vm.$route.query[keys[key]] : null
      if (obj) {
        let filter = '&filter[]=' + keys[key] + ':'
        for (let i = 0; i < obj.length; i++) {
          filter = filter + obj[i]
          if (i !== 0 && i !== obj.length - 1) {
            filter = filter + ','
          }
        }
        result = result + filter
      }
    }
    return result
  },
}
